import { render, staticRenderFns } from "./SupervisionPage.vue?vue&type=template&id=dd4a740c&scoped=true"
import script from "./SupervisionPage.vue?vue&type=script&lang=ts"
export * from "./SupervisionPage.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dd4a740c",
  null
  
)

export default component.exports